import { Navigate } from 'react-router-dom';

export default function Governance() {
  return <Navigate to="/dashboard" replace />;
}
